import React, {  useState } from "react";
import { connect  } from "react-redux";
import { removwAdminFromSchool } from "../../../actions/Members.actions";
import { Modal, message ,Button} from 'antd';


const RemoveAdminToSchool = ({ removwAdminFromSchool, id ,schoolID }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const AddAdmin = () => {
    removwAdminFromSchool(id ,schoolID );
    message.success("تم حذف   المسؤول");
    setIsModalVisible(false);
  };
  return (

<>{/*  eslint-disable-next-line */}
      <a  onClick={showModal}>
      حذف كمسؤول
      </a>
      <Modal title="تأكيد الطلب " visible={isModalVisible} footer={[
            <Button key="back" onClick={handleCancel}>
              إلغاء الامر
            </Button>,
            <Button key="submit" type="primary"  onClick={AddAdmin}>
              نعم
            </Button>,
          ]}>
        <p>هل انت متأكد من حذف  المسؤول </p>

      </Modal>
    </>
      
     
  );
};

export default connect(null, {
  removwAdminFromSchool,
})(RemoveAdminToSchool);
